<script>
import eventUtils from '@/mixins/eventUtils'
import TimeDurEvent from '@/components/events/TimeDurEvent.vue'
import moment from 'moment-timezone'

export default {
  name: 'Event',
  components: { TimeDurEvent },
  mixins: [eventUtils],
  props: {
    event: Object,
    active: Boolean,
  },
  computed: {
    typeCourseName() {
      return this.event.type?.title
    },
    dateStr() {
      return moment(this.event?.time_start).format('MMM DD ∙ HH:mm').replace('.', '');
    }
  }
}
</script>

<template>
  <div class="event-small-block" :class="{active: active}">
    <div class="head">
      <div
        class="badge"
        :style="`background-color: ${colorBadgeTypeEvent.bg}; color: ${colorBadgeTypeEvent.text}`"
        v-if="typeCourseName"
        v-text="typeCourseName"
      />
      <div class="date">{{dateStr}}</div>
    </div>
    <div class="title">{{event.name}}</div>
  </div>
</template>

<style lang="scss">
.event-small-block {
  padding: 10px 20px 20px;

  background: #FFFFFF;
  border-radius: 13px;
  cursor: pointer;

  &:hover {
    box-shadow: 0 5px 21px rgba(204, 215, 230, 0.2);
  }

  &.active {
    box-shadow: 0 5px 21px rgba(204, 215, 230, 0.3);
  }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .date {
      font-size: 12px;
    }
  }
  .title {
    font-size: 15px;
    font-weight: 700;

    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}
</style>
